import { DOMHelper } from "../Helpers/DOMHelper.js";
import { PmDatalayer } from "./PmDatalayer.js";

export class PmVLPDatalayer extends PmDatalayer{

    constructor(pmDrsApi) {
        super(pmDrsApi);
    }

    init() {
        if(!('VLP' in window)){
            console.log("skip PmVLPDatalayer, no VLP");
            return;
        }
        this.addHandlers();
    }

    addHandlers() {
        var dataLayer = this;

        var generalClickEvents = [
            { selector: '.cta-button', element: 'cta button' },        
        ];

        generalClickEvents.forEach((item)=> {            
            DOMHelper.addHandler(
                item.selector, 
                "click", 
                (event) => {                    
                    console.log("Pm dataLayer selector: " + item.selector);
                    dataLayer.ctaClickEvent(PmVLPDatalayer.DATALAYER_SECTION, item.element, event.target);
                }
            );
        });
    }


}

PmVLPDatalayer.DATALAYER_SECTION = "vlp";